import { render, staticRenderFns } from "./DataTableTransformValueColumn.vue?vue&type=template&id=d7d5d538&"
import script from "./DataTableTransformValueColumn.vue?vue&type=script&lang=js&"
export * from "./DataTableTransformValueColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports